// swipe
const serviceBanana01 = require('common/pc/images/service_banana01.png')
const serviceBanana03 = require('common/pc/images/service_banana03.png')
const serviceBanana04 = require('common/pc/images/service_banana04.png')

const fjdjt = require('common/pc/images/fjdjt.jpg')
const zzzs = require('common/pc/images/zzzs.jpg')
const lysj = require('common/pc/images/lysj.jpg')
// 服务动态
const mainService = require('common/pc/images/main_service.png')
const secondService = require('common/pc/images/second_service.png')

const data = {
  mainServer: [
    {
      bakImg: serviceBanana01,
      title: '附近的教堂',
      intro: '便捷的小程序，让你更快找到“家”',
      qrImg: fjdjt,
      scanTxt: '微信扫码体验',
      scanDetail: null,
      typeCt: null
    },
    {
      bakImg: serviceBanana03,
      title: '良友圣经学院',
      intro: '主内私人管理工具',
      qrImg: lysj,
      scanTxt: '微信扫码体验',
      scanDetail: null,
      typeCt: null
    },
    {
      bakImg: serviceBanana04,
      title: '组长助手',
      intro: '小组日常通勤轻量管理、打卡统计',
      qrImg: zzzs,
      scanTxt: '微信扫码体验',
      scanDetail: null,
      typeCt: null
    }
  ],
  serverActive: [
    {
      title: '附近教堂',
      img: mainService,
      more: null,
      content: [
        {
          item: '版本 v 1.1.1 发布上线了',
          date: '2018-11-02'
        },
        {
          item: '版本 v 1.0.2 发布上线了',
          date: '2018-09-10'
        },
        {
          item: '版本 v 1.0.1 发布上线了',
          date: '2018-05-17'
        },
        {
          item: '版本 v 1.0.0 发布上线了',
          date: '2018-04-15'
        }
      ]
    },
    {
      title: '组长助手',
      img: secondService,
      more: null,
      content: [
        {
          item: '组长助手发布啦~~',
          date: '2019-04-02'
        }
      ]
    }
  ]
}
export default data



// WEBPACK FOOTER //
// ./src/common/pc/js/server.js